module.exports = __webpack_public_path__ + "img/g16.264fc972.jpg";